import { Box, Button, makeStyles } from '@material-ui/core';
import React, { FC } from 'react';
import { ChromePicker } from 'react-color';
import { useDispatch } from 'react-redux';
import useComponentVisible from 'src/hooks/useComponentVisible';
import colorRectangle from 'src/images/colorRectangle.png';
import { RootState, useSelector } from 'src/store';
// import {
//   editText,
//   editFontWeight,
//   editColor,
//   editFontSize,
//   editTextAlign,
//   editFontFamily
// } from 'src/store/modules/editText';

// import Plus from 'src/components/Icon/Plus';
// import Minus from 'src/components/Icon/Minus';
// import AlignLeft from 'src/components/Icon/AlignLeft';
// import AlignCenter from 'src/components/Icon/AlignCenter';
// import AlignRight from 'src/components/Icon/AlignRight';

// import ChevronUp from 'src/components/Icon/ChevronUp';
// import ChevronDown from 'src/components/Icon/ChevronDown';
// import FontFamilyPicker from '../FontFamilyPicker';
import { editBgColor } from 'src/store/modules/imageUpload';

interface editTextProps {
  menuTitle: string;
  type: string;
}

// const FONT_WEIGHT_ENUM: any = {
//   300: 'Light',
//   400: 'Regular',
//   500: 'Medium',
//   600: 'SemiBold',
//   700: 'Bold'
// };

const useStyles = makeStyles(() => ({
  root: {
    padding: '1.5rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
    border: '1px solid #dddddd'
  },
  fontBox: {
    width: '100%',
    height: '2.5rem',
    padding: '0.5rem',

    cursor: 'pointer',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #D9D9D9'
  },
  input: {
    height: '4.5rem',
    padding: '0.5rem',
    outline: 'none',
    overflow: 'hidden',

    '&:focus': {
      border: 0,
      outline: 'none'
    },

    border: '1px solid #dddddd'
  },
  inputRoot: {
    padding: 0,
    height: '100%',
    display: 'block'
  },
  inputText: {
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '1.2rem',
    letterSpacing: '0.015rem'
  },

  bottomBtn: {
    padding: '0.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    border: '1px solid #dddddd',
    backgroundColor: '#F2F2F2'
  },
  btnMinusPlus: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem',
    padding: 0,
    display: 'flex'
  },

  fontNumber: {
    width: '3rem',
    height: '1.5rem',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    backgroundColor: '#fff'
  },

  buttonWrapper: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem'
  },
  buttonImage: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem'
  },

  boxWrapper: {
    // margin: '0 0.5rem',
    display: 'flex',
    justifyContent: 'space-between'
  },
  colorBox: {
    padding: '0.25rem 0.5rem',
    borderRadius: '0.25rem',
    border: '1px solid #D9D9D9',
    textAlign: 'center',

    color: '#000',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400
  },
  textAlign: {
    cursor: 'pointer'
  }
}));

const EditBgColor: FC<editTextProps> = ({ menuTitle, type }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);

  const {
    refPicker,
    refButton1,
    refButton2,
    isComponentVisible,
    setIsComponentVisible
  } = useComponentVisible(false);

  const handleColor = c => {
    const newBgColor = JSON.parse(`{"${type}": "${c.hex}"}`);
    dispatch(editBgColor({ ...bgColor, ...newBgColor }));
  };

  return (
    <div className={classes.root}>
      <div
        style={{
          fontSize: '0.875rem',
          fontWeight: 600,
          fontFamily: 'Archivo',
          letterSpacing: '0.0175rem'
        }}
      >
        {menuTitle}
      </div>
      <div>
        <Box className={classes.boxWrapper}>
          <BgColor
            type={type}
            picker={{
              refPicker,
              refButton1,
              refButton2,
              isComponentVisible,
              setIsComponentVisible
            }}
          />
        </Box>
        {isComponentVisible && (
          <div ref={refPicker} style={{ width: '100%', marginTop: '1rem' }}>
            <ChromePicker
              color={bgColor[type]}
              onChange={handleColor}
              disableAlpha
              width="100%"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default EditBgColor;

export const BgColor = ({ type, picker }: any) => {
  const classes = useStyles();
  // const dispatch = useDispatch();

  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);

  const handleColorPicker = () => {
    picker.setIsComponentVisible(!picker.isComponentVisible);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
      <Button
        ref={picker.refButton1}
        onClick={handleColorPicker}
        className={classes.buttonWrapper}
      >
        <img alt="color" src={colorRectangle} className={classes.buttonImage} />
      </Button>
      <Button
        ref={picker.refButton2}
        style={{
          maxWidth: '1.25rem',
          minWidth: '1.25rem',
          maxHeight: '1.25rem',
          minHeight: '1.25rem',
          padding: 0
        }}
        onClick={handleColorPicker}
      >
        <div
          style={{
            width: '1.25rem',
            height: '1.25rem',
            backgroundColor: bgColor[type],
            border: '1px solid #D9D9D9',
            borderRadius: 999
          }}
        />
      </Button>

      <div className={classes.colorBox}>{bgColor[type]?.toUpperCase()}</div>
    </div>
  );
};
